import { Input, Component, OnChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { AbstractValueAccessor, MakeProvider } from './abstract-value-accessor';
import { FormField, SelectItem } from '../models/form-field';
import { DynamicFormFieldComponent } from './dynamic-form-field.component';
import { SelectComponent } from '../widgets/select.component';
import { SegmentComponent } from '../widgets/segment.component';
import { Util } from '../utils/utils.module';

@Component({
  selector: 'edx-select-field',
  providers: [MakeProvider(SelectFieldComponent)],
  styleUrls: ['dynamic-form-field.component.scss'],
  template: `
  <div [formGroup]="form" class="indialog" [ngClass]="{columnview: columnView, controlcontainer: !useSeg, fullwidth: fullWidth}">
    @if (!useSeg) {
      <edx-select [value]="value" [items]="items" [isSysParamsSelect] = "isSysParamsSelect" [ariaLabel]="!!ariaLabel?ariaLabel:field.name" [isMultiSelect]="field.multiSelect" [multiSelectSep]="field.multiSelectSep" [required]="field.isRequired ? true : null" [title]="field.name" [id]="field.name" [disabled]="disabled" [initialPlaceHolder]="initialPlaceHolder" [justButton]="field.justComboButton" [inDialog]="inDialog" [inHeader]="inHeader" [inNotify]="inNotify" (change)="changed($event)" [tabIndex]="tabIndex" [previewOnly]="previewOnly"></edx-select>
    }
    @if (isSysParamsSelect) {
      <span [title]="field.label" class="checklabel checkboxlabel" [attr.aria-label]="field.label" [id]="field.name" role="checkbox">{{field.label}}</span>
    }
    @if (useSeg) {
      <edx-segment [value]="value" [items]="items" [required]="field.isRequired ? true : null" [id]="field.name" [disabled]="disabled" (change)="changed($event)" [tabIndex]="tabIndex"></edx-segment>
    }
  </div>
  `,
  standalone: false
})
export class SelectFieldComponent extends AbstractValueAccessor implements OnChanges {
  @Input() items: SelectItem[] = [];
  @Input() field: FormField;
  @Input() form: FormGroup;
  @Input() parent: DynamicFormFieldComponent;
  @Input() initialPlaceHolder?: string;
  @Input() formReadonly?: boolean = false;
  @Input() previewOnly?: boolean = false;
  @Input() columnView?: boolean = false;
  @Input() fullWidth?: boolean = false;
  @Input() inDialog?: boolean = false;
  @Input() inNotify?: boolean = false;
  @Input() inHeader?: boolean = false;
  @Input() rerender = 0;
  @Input() tabIndex = 0;
  @Input() ariaLabel?: string = '';
  @Input() isSysParamsSelect: boolean;
  public useSeg = false;
  private disabled = false;

  ngOnChanges() {
    if (!this.value && this.field.defaultValue) {
      this.value = this.field.defaultValue;
    }
    if (this.isSecurityFieldReadonly()) {
      this.field.isReadonly = true;
    }
    this.disabled = this.field.isReadonly || !this.field.isEnabled || this.formReadonly || this.previewOnly;
    if (!this.field.isEnabled && this.field.name === 'email_as_default') {
      this.previewOnly = true;
    }
    this.useSeg = this.field.comboSegment;
  }

  public changed(component: SelectComponent | SegmentComponent): void {
    this.value = component.value;
    this.parent.updateControlValue(this.value, true);
    this.parent.fieldChanged();
  }

  private isSecurityFieldReadonly(): boolean {
    const parent = this.parent?.parent;
    if (!parent) return false;

    const isSecurityField = this.field?.name === 'SECURITY';
    const hasCreateType = !!parent.createType;
    const securityNotUnrestricted = (this.field?.selectionMap?.findIndex(t => t?.value === '0') === -1) || (parent.desc?.['SECURITY'] !== '0');
    const hasDocuments = !parent.data?.DOCUMENTS || parent.data?.DOCUMENTS?.length <= 1;
    const isRestrictionEnforcedType = (['preferences', 'flexfolders'].indexOf(parent.desc?.type) < 0) && !(parent.desc?.type === 'admin' && parent.desc?.id === 'groups');
    const forceRestricted = (Util.RestAPI.getSystemDefaultSetting('FORCE_RESTRICTED') || 'N') === 'Y';

    return forceRestricted &&
      isSecurityField &&
      (hasCreateType || securityNotUnrestricted) &&
      hasDocuments &&
      isRestrictionEnforcedType;
  }
}
